import { gql } from "@apollo/client";

export const LIST_STUDIOS = gql`
  query ListStudios(
    $filter: ModelStudioFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStudios(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        status
        StudioName
        images
        studioLocation
        pricePerHour
        image
        description
        userID
        studioTypes
        studioSize
        numberOfPeople
        city
        postcode
        User {
          id
          firstName
          lastName
          profilePicture
          numberOfStudios
          __typename
        }
        country
        approxLatitude
        approxLongitude
        locationLabel
        locationPrecision
        minNumberOfHours
        amenities
        equipment {
          nextToken
          __typename
        }
        availabilities {
          nextToken
          __typename
        }
        bookings {
          nextToken
          __typename
        }
        wishListStudios {
          nextToken
          __typename
        }
        chatRooms {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const LIST_BOOKINGS_BY_STUDIO = gql`
  query BookingsByStudioID(
    $studioID: ID!
    $filter: ModelBookingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    bookingsByStudioID(
      studioID: $studioID
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        startDateTime
        endDateTime 
        status
      }
    }
  }
`;

export const BOOKINGS_BY_STUDIO_ID = gql`
  query BookingsByStudioID(
    $studioID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelBookingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    bookingsByStudioID(
      studioID: $studioID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        chatRoomID
        studioID
        userID
        startDateTime
        endDateTime
        totalPrice
        status
        projectName
        companyName
        projectDescription
        cancelledBy
        cancelledAt
        cancellationReason
        createdAt
        Studio {
          id
          StudioName
          images
          city
          postcode
          locationLabel
          User {
            id
            firstName
            lastName
            profilePicture
          }
        }
        User {
          id
          firstName
          lastName
          profilePicture
        }
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const AVAILABILITIES_BY_STUDIO_ID = gql`
  query AvailabilitiesByStudioID(
    $studioID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelAvailabilityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    availabilitiesByStudioID(
      studioID: $studioID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        studioID
        dayOfWeek
        startTime
        endTime
        Studio {
          id
          StudioName
          images
          studioLocation
          pricePerHour
          image
          description
          userID
          studioTypes
          studioSize
          numberOfPeople
          city
          postcode
          country
          approxLatitude
          approxLongitude
          locationLabel
          locationPrecision
          minNumberOfHours
          amenities
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const BLOCKED_TIMES_BY_STUDIO_ID = gql`
  query BlockedTimesByStudioID(
    $studioID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelBlockedTimeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    blockedTimesByStudioID(
      studioID: $studioID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        studioID
        title
        startDateTime
        endDateTime
        isFullDay
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const GET_STUDIO_AVAILABILITIES = gql`
  query GetStudioAvailabilities($studioId: ID!) {
    getStudio(id: $studioId) {
      id
      availabilities {
        items {
          id
          studioID
          dayOfWeek
          startTime
          endTime
        }
      }
    }
  }
`;
